import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Icon from '@mdi/react'
import { mdiEyeOutline } from '@mdi/js'

import { fetchAddonCharge, fetchAddonCharges } from '../SubscriptionActions'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import colors from '../../../assets/colors'
import { dateFormatedPT } from '../../../util/utils'

import AddonChargeDetails from './AddonChargeDetailsModal'
import Filter from './AddonChargesFilter'
import StatusChip, { getInvoiceStatusTone } from './Forms/StatusChip'

const AddonCharges = () => {
  const dispatch = useDispatch()

  const charges = useSelector(state => state.subscription.addonCharges)
  const summary = useSelector(state => state.subscription.addonChargesSummary)

  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(!open)
  }

  useEffect(() => {
    dispatch(fetchAddonCharges())
  }, [])

  const handleViewCharge = id => {
    dispatch(fetchAddonCharge(id))
    handleClose()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Filter />
      </Grid>

      {!!summary?.count && (
        <Grid item xs={12}>
          <Box style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Typography style={{ fontSize: '13px', color: colors.textPrimary }}>
              Pago:{' '}
              <b style={{ color: colors.sucess }}>
                R$ {((summary.total_paid || 0) / 100).toFixed(2)}
              </b>
            </Typography>
            <Typography style={{ fontSize: '13px', color: colors.textPrimary }}>
              Pendente:{' '}
              <b style={{ color: colors.info }}>
                R$ {((summary.total_pending || 0) / 100).toFixed(2)}
              </b>
            </Typography>
            <Typography style={{ fontSize: '13px', color: colors.textPrimary }}>
              Falhou:{' '}
              <b style={{ color: colors.error }}>
                R$ {((summary.total_failed || 0) / 100).toFixed(2)}
              </b>
            </Typography>
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        <TableContainer>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <StyledTableCellHeader>Serviço</StyledTableCellHeader>
                <StyledTableCellHeader>Origem</StyledTableCellHeader>
                <StyledTableCellHeader align="center">
                  Qtd.
                </StyledTableCellHeader>
                <StyledTableCellHeader align="center">
                  Valor
                </StyledTableCellHeader>
                <StyledTableCellHeader>
                  Método de Pagamento
                </StyledTableCellHeader>
                <StyledTableCellHeader align="center">
                  Data da Cobrança
                </StyledTableCellHeader>
                <StyledTableCellHeader align="center">
                  Status
                </StyledTableCellHeader>
                <StyledTableCellHeader align="right">
                  Ações
                </StyledTableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {charges.map((item, index) => (
                <TableRow key={index}>
                  <StyledTableCellBody>
                    {item.addon_service_name}
                  </StyledTableCellBody>
                  <StyledTableCellBody>{item.source_text}</StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {item.quantity}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {item.amount_formatted}
                  </StyledTableCellBody>
                  <StyledTableCellBody>
                    {item.payment_method}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {dateFormatedPT(item.created_at)}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    <StatusChip
                      label={item?.status_text}
                      tone={getInvoiceStatusTone(null, item?.status_text)}
                    />
                  </StyledTableCellBody>
                  <StyledTableCellBody align="right">
                    <IconButton
                      style={{ padding: '0px' }}
                      onClick={() => {
                        handleViewCharge(item?.id)
                      }}
                      title="Ver cobrança"
                      aria-label="ver cobrança"
                    >
                      <Icon path={mdiEyeOutline} size={1} />
                    </IconButton>
                  </StyledTableCellBody>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <AddonChargeDetails open={open} handleClose={handleClose} />
    </Grid>
  )
}

export default AddonCharges
